/**
 * Module de monitoring centralisé.
 * Envoie les logs vers le Dashboard ERP pour surveiller la santé technique du site.
 */

/**
 * Récupère le contexte système et matériel du client en toute sécurité.
 */
function getSystemContext() {
  if (typeof window === "undefined") return { env: "server-side" };

  const nav = navigator;
  const conn =
    nav.connection || nav.mozConnection || nav.webkitConnection || {};
  const perf = window.performance;

  return {
    // Navigation
    url: window.location.href,
    path: window.location.pathname,
    referrer: document.referrer || null,

    // Navigateur
    userAgent: nav.userAgent,
    language: nav.language,
    languages: nav.languages ? [...nav.languages] : [],
    cookiesEnabled: nav.cookieEnabled,
    online: nav.onLine,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    // Écran
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio,

    // Réseau (si disponible)
    connectionType: conn.effectiveType || null,
    connectionDownlink: conn.downlink || null,

    // Performance (Chrome uniquement en général)
    memoryUsage: perf.memory
      ? {
          usedJSHeapSize: perf.memory.usedJSHeapSize,
          totalJSHeapSize: perf.memory.totalJSHeapSize,
        }
      : null,

    // Session utilisateur (si disponible)
    sessionUser: {
      name: sessionStorage.getItem("name") || null,
      email: sessionStorage.getItem("email") || null,
      uid: sessionStorage.getItem("uid") || null,
    },

    timestamp: new Date().toISOString(),
  };
}

/**
 * Envoie un log vers le Dashboard ERP centralisé.
 * Ne JAMAIS faire throw d'erreur ici pour ne pas bloquer l'app client.
 *
 * @param {"INFO"|"WARN"|"ERROR"|"CRITICAL"} level - Niveau de sévérité
 * @param {"AUTH"|"DB"|"UI"|"PAYMENT"|"SYSTEM"|"OTHER"} category - Catégorie du log
 * @param {string} message - Description de l'événement
 * @param {Record<string, unknown>} customContext - Contexte additionnel spécifique à l'événement
 */
export async function logEvent(level, category, message, customContext = {}) {
  try {
    const API_KEY = process.env.REACT_APP_MONITORING_API_KEY;

    // Fusion du contexte automatique et du contexte spécifique
    const fullContext = {
      ...getSystemContext(),
      ...customContext,
    };

    await fetch("https://logevent-ta6wobnraq-ew.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
      body: JSON.stringify({
        level,
        category,
        message,
        context: fullContext,
      }),
    });
  } catch (e) {
    // Failsafe silencieux : si le monitoring tombe, le site client doit continuer de fonctionner.
    console.error("Monitoring API unavailable");
  }
}
